
import FormCustom from "./Component";

FormCustom.install = function (Vue) {
  Vue.component(FormCustom.name, FormCustom);
  // Vue.component("form-custom", FormCustom);
};

// 导出该组件
export default FormCustom;